export default "__VITE_ASSET__DOq6h9Ql__"